import { render, staticRenderFns } from "./FloatingActionButton.vue?vue&type=template&id=c1c938aa&scoped=true"
import script from "./FloatingActionButton.vue?vue&type=script&lang=js"
export * from "./FloatingActionButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingActionButton.vue?vue&type=style&index=0&id=c1c938aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c938aa",
  null
  
)

export default component.exports